const Statistics = () => import(/* webpackChunkName: "Statistics" */ './containers/Statistics');
const Game = () => import(/* webpackChunkName: "Game" */ './components/Game');
const Question = () => import(/* webpackChunkName: "Question" */ './components/Question');
const Player = () => import(/* webpackChunkName: "Player" */ './components/Player');
const Financial = () => import(/* webpackChunkName: "Financial" */ './components/Financial');

export const statisticsRouting = [
    {
        path: '/statistics', name: 'statistics', component: Statistics,
        children: [
            {path: '/', redirect: 'game'},
            {path: 'game', name: 'game', component: Game},
            {path: 'question', name: 'question', component: Question},
            {path: 'player', name: 'player', component: Player},
            {path: 'financial', name: 'financial', component: Financial}
        ]
    }
]
